/**
 * Tasks documentation page — creating reusable task definitions attached to teammates.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { tasksContent } from "@/constants/docs/tasks";

export const Route = createFileRoute("/docs/tasks")({
	component: TasksPage,
});

function TasksPage() {
	return <DocsPage title="Tasks" content={tasksContent} />;
}
